export class DisertacijosFormCtrl {
    constructor($scope, $http) {
        'ngInject';
        this.$scope = $scope;
        this.$http = $http;

        const g = (typeof window !== 'undefined') ? window : {};

        this.mode      = g.formMode || 'create';
        this.submitUrl = g.formSubmitUrl || '';
        this.backUrl   = g.formBackUrl || '';
        this.selects   = g.formSelects || {apginta:[], institucijos:[], kryptys:[]};
        this.model     = g.formItem ? {...g.formItem} : {};
        this.confirmPatvirtinti = g.formConfirmPatvirtinti || '';
        this.locked    = g.formLocked || false;
        this.canEditPateikta = g.formCanEditPateikta || false;
        this.isLibrarianOnly = g.formIsLibrarianOnly || false;

        const toDate = v => {
            if (!v || v === '0') return null;
            if (typeof v === 'number') return new Date(v * 1000);
            if (typeof v === 'string' && /^\d+$/.test(v)) return new Date(parseInt(v,10) * 1000);
            const ts = Date.parse(v);
            return isNaN(ts) ? null : new Date(ts);
        };

        this.model.dateObj        = toDate(this.model.date) || null;
        this.model.birthDateObj   = toDate(this.model.birth_date) || null;
        this.model.docGradDateObj = toDate(this.model.doc_grad_date) || null;
        this.model.diplomaDateObj = toDate(this.model.diploma_date) || null;
        this.model.tbpsDateObj    = toDate(this.model.tbps_date) || null;

        const dt = toDate(this.model.datetime);
        if (dt) {
            this.model.datetimeDateObj = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
            this.model.time_h = dt.getHours();
            this.model.time_m = dt.getMinutes();
        } else {
            this.model.datetimeDateObj = null;
            this.model.time_h = null;
            this.model.time_m = null;
        }

        const as01 = v => (v === 1 || v === '1' || v === true || v === 'true') ? 1 : 0;
        ['active','patvirtinta','pateikta'].forEach(k => {
            if (k in this.model) this.model[k] = as01(this.model[k]);
        });
        if ('apginta' in this.model) {
            const v = parseInt(this.model.apginta, 10);
            this.model.apginta = isNaN(v) ? -1 : v;
        }

        this._attLimit = 4;

        const raw = (g.formAttachments || g.formAtachments || []);
        this.attachments = raw
            .filter(x => x && x.data && x.data.filesystem_id)
            .map(x => {
                const name = x.name || ('file' + (x.nr || '1'));
                return {...x, name};
            });

        this.canAddAttachment = () => {
            const alive = this.attachments.filter(a => !a._removed).length;
            return alive < this._attLimit;
        };

        this.addAttachment = () => {
            if (!this.canAddAttachment()) { return; }
            let maxNum = 0;
            this.attachments.forEach(a => {
                const m = /^file(\d+)$/.exec(a && a.name ? String(a.name) : '');
                if (m) {
                    const n = parseInt(m[1], 10);
                    if (!isNaN(n) && n > maxNum) maxNum = n;
                }
            });
            const next = Math.max(maxNum + 1, this.attachments.length + 1);
            const name = 'file' + next;
            this.attachments.push({ name });
        };

        this.removeAttachment = (index) => {
            const item = this.attachments[index];
            if (!item) return;
            if (item.data && item.data.filesystem_id) {
                item._removed = true;
                item.del = 'on';
            } else {
                this.attachments.splice(index, 1);
            }
        };

        this.onFilePickedFromEl = (ev) => {
            const el = ev && ev.target ? ev.target : null;
            if (!el) return;
            const slot = el.getAttribute('data-att');
            const file = el.files && el.files[0];
            if (!slot || !file) return;
            const idx = this.attachments.findIndex(a => a && a.name === slot);
            if (idx >= 0) {
                this.attachments[idx]._fileName = file.name;
                this.attachments[idx]._removed = false;
                this.attachments[idx].del = false;
            }
            this.$scope.$applyAsync();
        };

        const formEl = document.querySelector('.thesis-form');
        if (formEl) {
            formEl.querySelectorAll('fieldset').forEach(fs => {
                if (fs.querySelector('textarea')) {
                    fs.style.cursor = 'text';
                }
            });

            formEl.addEventListener('click', (e) => {
                const fieldset = e.target.closest('fieldset');
                if (!fieldset) return;
                if (e.target.closest('textarea, input, select, md-select, button, a, md-datepicker')) return;
                const target = fieldset.querySelector('textarea, input:not([type="file"]):not([type="hidden"])');
                if (target) target.focus();
            });
        }
    }

    submit() {
        if (!this.submitUrl) return;

        if (this.mode === 'create' && !this.model.institucija_kas) {
            alert('Prašome pasirinkti skelbiančią instituciją.');
            return;
        }

        const as01 = v => (v === 1 || v === '1' || v === true || v === 'true') ? 1 : 0;
        if (as01(this.model.patvirtinta) === 1 && this.confirmPatvirtinti) {
            if (!confirm(this.confirmPatvirtinti)) {
                return;
            }
        }

        const out = {...this.model};
        const fromDate = d => (d instanceof Date && !isNaN(d.getTime())) ? Math.floor(d.getTime()/1000) : 0;

        out.date          = fromDate(out.dateObj);
        out.birth_date    = fromDate(out.birthDateObj);
        out.doc_grad_date = fromDate(out.docGradDateObj);
        out.diploma_date  = fromDate(out.diplomaDateObj);
        out.tbps_date     = fromDate(out.tbpsDateObj);

        let hh = (out.time_h==null?0:parseInt(out.time_h,10));
        let mm = (out.time_m==null?0:parseInt(out.time_m,10));
        if (isNaN(hh) || hh<0) hh = 0; if (hh>23) hh = 23;
        if (isNaN(mm) || mm<0) mm = 0; if (mm>59) mm = 59;

        if (out.datetimeDateObj instanceof Date && !isNaN(out.datetimeDateObj.getTime())) {
            const d = new Date(out.datetimeDateObj.getFullYear(), out.datetimeDateObj.getMonth(), out.datetimeDateObj.getDate(), hh, mm, 0);
            out.datetime = Math.floor(d.getTime()/1000);
        } else {
            out.datetime = 0;
        }

        delete out.dateObj;
        delete out.birthDateObj;
        delete out.docGradDateObj;
        delete out.diplomaDateObj;
        delete out.tbpsDateObj;
        delete out.datetimeDateObj;
        delete out.time_h;
        delete out.time_m;

        out.active      = as01(out.active);
        out.patvirtinta = as01(out.patvirtinta);
        out.pateikta    = as01(out.pateikta);
        out.apginta     = parseInt(out.apginta, 10);
        if (isNaN(out.apginta)) out.apginta = -1;

        const fd = new FormData();
        Object.keys(out).forEach(k => {
            const v = out[k];
            if (v === undefined) return;
            if (v === null) { fd.append(k, ''); return; }
            if (typeof v === 'object') return;
            fd.append(k, v);
        });

        const formEl = document.querySelector('.thesis-form');
        const fileInputs = formEl ? formEl.querySelectorAll('input[type="file"][name]') : [];
        Array.prototype.forEach.call(fileInputs, el => {
            if (el.files && el.files.length > 0) {
                fd.append(el.name, el.files[0]);
            }
        });

        if (this.del_protokolo_kopija) fd.append('del_protokolo_kopija', '1');
        if (this.del_diplomo_kopija) fd.append('del_diplomo_kopija', '1');

        if (Array.isArray(this.attachments)) {
           this.attachments.forEach(a => {
                 if (a && a.del) fd.append('deldoc[' + a.name + ']', a.del);
               });
         }

        if (formEl) {
            const filemapInputs = formEl.querySelectorAll('input[name^="filemap["]');
            Array.prototype.forEach.call(filemapInputs, el => {
                fd.append(el.name, el.value || '');
            });
        }

        const req = {
            url: this.submitUrl,
            method: 'POST',
            data: fd,
            headers: { 'Content-Type': undefined },
            transformRequest: angular.identity,
            responseType: 'json'
        };
        const onOk = res => {
            const payload = res && res.data ? res.data : res;
            if (payload && payload.success) {
                if (as01(this.model.patvirtinta) === 1) {
                    this.locked = true;
                    this.$scope.$applyAsync();
                }
                if (payload.redirect) {
                    window.location.assign(payload.redirect);
                }
                return;
            }
            if (payload && payload.message === 'forbidden') {
                alert('Nepavyko išsaugoti - Jūsų sesija pasibaigė. Prašome prisijungti iš naujo.');
                return;
            }
            const instMsgs = {
                forbidden_institution_empty: 'Nepavyko išsaugoti - nepasirinkta skelbianti institucija.',
                forbidden_institution_new: 'Nepavyko išsaugoti - neturite teisių pasirinktai skelbiančiai institucijai.',
                forbidden_institution_edit: 'Nepavyko išsaugoti - neturite teisių šiai institucijai.',
                forbidden_institution_foreign: 'Nepavyko išsaugoti - šis įrašas priklauso kitai institucijai.',
                forbidden_institution: 'Nepavyko išsaugoti - Jūs neturite teisių pasirinktai institucijai.',
            };
            if (payload && instMsgs[payload.message]) {
                alert(instMsgs[payload.message]);
                return;
            }
            if (payload && payload.message === 'forbidden_state') {
                alert('Nepavyko išsaugoti - įrašas patvirtintas, redaguoti nebegalima.');
                return;
            }
            if (payload && payload.errors) {
                alert('Nepavyko išsaugoti. Patikrinkite, ar visi privalomi laukai užpildyti.');
                return;
            }
        };

        if (typeof this.$scope.basicHttpConfigProcess === 'function') {
            this.$scope.basicHttpConfigProcess(req).then(onOk);
        } else {
            this.$http(req).then(onOk);
        }
    }
}
